import Email from '@elem/SVGIcon/DeltaProUltra/Email';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useLang, gtm } = useGlobal();
    const { t } = useLang('delta_pro_ultra.teaser');
    const handleToEmail = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'bottom_function',
            button_name: 'None',
        });
        const target = document.querySelector('.delta-pro-ultra-B') as HTMLElement;
        window.scrollTo({
            top: target.offsetTop,
            behavior: 'smooth',
        });
    };
    return (
        <div className={`delta-pro-ultra-A ${css['delta-pro-ultra-A']}`}>
            <div className="banner-static">
                <EFPicture
                    src={'/responsive/picture/delta-pro-ultra/teaser.jpg'}
                    srcPad={'/responsive/picture/delta-pro-ultra/teaser_768.jpg'}
                    srcMobile={'/responsive/picture/delta-pro-ultra/teaser_375.jpg'}
                    alt={t('secA_title')}
                />
                <div className="banner-box">
                    {/* <div className="banner-title">
                        <Title className="icon-title title" />
                        <Title1366 className="icon-title title_1366" />
                        <Title768 className="icon-title title_768" />
                        <Title375 className="icon-title title_375" />
                    </div> */}
                    <p className="banner-title">{t('secA_title')}</p>
                    <p className="banner-subtitle">{t('secA_subtitle')}</p>
                    <p className="banner-desc">{t('secA_desc')}</p>
                </div>
            </div>
            <p className="text">{t('secA_text')}</p>
            <Email className="email-icon" onClick={handleToEmail} />
        </div>
    );
}
